import { t } from 'lib/i18n'

import { CataloguePage } from './CataloguePage'

/** Honest subset of Figma's "Crew" screen buildable today: the trades/job-title reference list.
 *  The subcontractor roster and per-trade aggregates in the mockup need new backend entities — see the plan's Phase 2. */
export const CrewTradesPage = () => (
  <CataloguePage
    kind="JOB_TITLE"
    title={t('الكوادر — الاختصاصات', 'Crew — trades')}
    description={t('قائمة المسميات الوظيفية المرجعية التي تظهر كاقتراحات عند تعبئة قسم الكوادر في التقرير.', 'Reference list of job titles suggested when filling in the crew section of a report.')}
    icon="users"
    itemLabel={t('اختصاصاً', 'trade')}
  />
)
